import { Color, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

interface PaymentTermSelectWrapperProps {
  isInputFocused?: boolean
}

export const PaymentTermSelectWrapper = styled.div<PaymentTermSelectWrapperProps>`
  padding: ${Spacing.S12} ${Spacing.S16};
  ${({ isInputFocused }) => {
    if (isInputFocused) {
      return css`
        background-color: ${Color.Grey100};
      `
    }
    return css`
      &:hover {
        background-color: ${Color.Black};

        span {
          color: ${Color.White};
        }
      }
    `
  }};
`
